import { default as IconRecordAccount } from "./account-record.svg";
import { default as IconAddUser } from "./add-user.svg";
import { default as IconArrowBack } from "./arrow-back.svg";
import { default as IconArrowDownLarge } from "./arrow-down-large.svg";
import { default as IconArrowDown } from "./arrow-down.svg";
import { default as IconArrowLeft } from "./arrow-left.svg";
import { default as IconArrowRight } from "./arrow-right.svg";
import { default as IconArrowUpLarge } from "./arrow-up-large.svg";
import { default as IconArrowUp } from "./arrow-up.svg";
import { default as IconBell } from "./bell.svg";
import { default as IconBluetooth } from "./bluetooth.svg";
import { default as IconCalendar } from "./calendar.svg";
import { default as IconCameraRefresh } from "./camera-refresh.svg";
import { default as IconCar } from "./car.svg";
import { default as IconChatUnread } from "./chat-unread.svg";
import { default as IconCheck } from "./check.svg";
import { default as IconCloseCircle } from "./close-circle.svg";
import { default as IconCloseLarge } from "./close-large.svg";
import { default as IconCloudUpload } from "./cloud-upload.svg";
import { default as IconCode } from "./code.svg";
import { default as IconConnection } from "./connection.svg";
import { default as IconRecordContact } from "./contact-record.svg";
import { default as IconCopy } from "./copy.svg";
import { default as IconDotsHorizontal } from "./dots-horizontal.svg";
import { default as IconDownload } from "./download.svg";
import { default as IconE2EE } from "./e2ee.svg";
import { default as IconEdit } from "./edit.svg";
import { default as IconEmotionsAngry } from "./emotions-angry.svg";
import { default as IconEmotionsDisgusted } from "./emotions-disgusted.svg";
import { default as IconEmotionsFearful } from "./emotions-fearful.svg";
import { default as IconEmotionsHappy } from "./emotions-happy.svg";
import { default as IconEmotionsNeutral } from "./emotions-neutral.svg";
import { default as IconEmotionsSad } from "./emotions-sad.svg";
import { default as IconEmotionsSurprised } from "./emotions-surprised.svg";
import { default as IconEnlarge } from "./enlarge.svg";
import { default as IconEnterFullscreen } from "./enter-fullscreen.svg";
import { default as IconEnvelope } from "./envelope.svg";
import { default as IconExclamationSolid } from "./exclamation-solid.svg";
import { default as IconExclamationTriangle } from "./exclamation-triangle.svg";
import { default as IconExitFullscreen } from "./exit-fullscreen.svg";
import { default as IconFaceSmile } from "./face-smile.svg";
import { default as IconFavoriteSolid } from "./favorite-solid.svg";
import { default as IconFavorite } from "./favorite.svg";
import { default as IconFeedback } from "./feedback.svg";
import { default as IconGear } from "./gear.svg";
import { default as IconGoogle } from "./google.svg";
import { default as IconHangup } from "./hangup.svg";
import { default as IconDeviceHeadphone } from "./headset.svg";
import { default as IconHelp } from "./help.svg";
import { default as IconHighlight } from "./highlight.svg";
import { default as IconRingGroup } from "./icon-ring-group.svg";
import { default as IconImage } from "./image.svg";
import { default as IconInfoCircle } from "./info-circle.svg";
import { default as IconInfo } from "./info.svg";
import { default as IconRecordLead } from "./lead-record.svg";
import { default as IconMessage } from "./message.svg";
import { default as IconMeter } from "./meter.svg";
import { default as IconMicSlash } from "./mic-slash.svg";
import { default as IconMic } from "./mic.svg";
import { default as IconModerator } from "./moderator.svg";
import { default as IconConnectionInactive } from "./ninja.svg";
import { default as IconNoiseSuppressionOff } from "./noise-suppression-off.svg";
import { default as IconNoiseSuppressionOn } from "./noise-suppression-on.svg";
import { default as IconOffice365 } from "./office365.svg";
import { default as IconRecordOpportunity } from "./opportunity-record.svg";
import { default as IconPerformance } from "./performance.svg";
import { default as IconPhoneRinging } from "./phone-ringing.svg";
import { default as IconPin } from "./pin.svg";
import { default as IconPinned } from "./pinned.svg";
import { default as IconPictureInPicture } from "./pip.svg";
import { default as IconPlay } from "./play.svg";
import { default as IconPlus } from "./plus.svg";
import { default as IconRaiseHand } from "./raise-hand.svg";
import { default as IconRecord } from "./record.svg";
import { default as IconReply } from "./reply.svg";
import { default as IconRestore } from "./restore.svg";
import { default as IconScreenshare } from "./screenshare.svg";
import { default as IconSearch } from "./search.svg";
import { default as IconSecurityOff } from "./security-off.svg";
import { default as IconSecurityOn } from "./security-on.svg";
import { default as IconSend } from "./send.svg";
import { default as IconShareDoc } from "./share-doc.svg";
import { default as IconShare } from "./share.svg";
import { default as IconShortcuts } from "./shortcuts.svg";
import { default as IconSip } from "./sip.svg";
import { default as IconSites } from "./sites.svg";
import { default as IconRemoteControlStart } from "./start-remote-control.svg";
import { default as IconRemoteControlStop } from "./stop-remote-control.svg";
import { default as IconStop } from "./stop.svg";
import { default as IconSubtitles } from "./subtitles.svg";
import { default as IconTileView } from "./tile-view.svg";
import { default as IconTrash } from "./trash.svg";
import { default as IconUserDeleted } from "./user-deleted.svg";
import { default as IconUser } from "./user.svg";
import { default as IconUsers } from "./users.svg";
import { default as IconVideoOff } from "./video-off.svg";
import { default as IconVideo } from "./video.svg";
import { default as IconAudioOnlyOff } from "./visibility-off.svg";
import { default as IconAudioOnly } from "./visibility.svg";
import { default as IconVolumeOff } from "./volume-off.svg";
import { default as IconVolumeUp } from "./volume-up.svg";
import { default as IconWarningCircle } from "./warning-circle.svg";
import { default as IconWarning } from "./warning.svg";
import { default as IconWhiteboardHide } from "./whiteboard-hide.svg";
import { default as IconWhiteboard } from "./whiteboard.svg";
import { default as IconWifi1Bar } from "./wifi-1.svg";
import { default as IconWifi2Bars } from "./wifi-2.svg";
import { default as IconWifi3Bars } from "./wifi-3.svg";
import { default as IconYahoo } from "./yahoo.svg";
import { default as IconClose } from "./close.svg";
import { default as IconAttachment } from "./attachment.svg";
import { default as IconImageCircle } from "./image-circle.svg";
import { default as IconArrowUpOutline } from "./arrow-up-outline.svg";
import { default as IconArrowDownOutline } from "./arrow-down-outline.svg";
import { default as IconFileAttachment } from "./file-attachment.svg";
import { default as IconVideoAttachment } from "./video-attachment.svg";
import { default as IconPDFAttachment } from "./pdf-attachment.svg";
import { default as IconMicWithBackground } from "./mic-with-background.svg";
import { default as IconVideoWithBackground } from "./video-with-background.svg";
import { default as IconCameraFlip } from "./camera-flip.svg";
import { default as IconAuditorNotes } from "./auditor-notes.svg";
import { default as IconAuditorNotesHeading } from "./auditor-notes-heading.svg";
import { default as IconAuditorNoteDelete } from "./auditor-note-delete.svg";
import { default as IconAuditorNoteClose } from "./auditor-note-close.svg";
import { default as IconAuditorNoteEdit } from "./auditor-note-edit.svg";
import { default as IconVirtualBackgroundFilled } from "./virtual-background-filled.svg";
import { default as IconHideCameraOff } from "./hide-camera-off.svg";
import { default as IconPermission } from "./permission.svg";
/**
 * Map containing the default icons.
 */
export const DEFAULT_ICON = {
    IconHideCameraOff,
    IconVirtualBackgroundFilled,
    IconCameraFlip,
    IconPDFAttachment,
    IconFileAttachment,
    IconVideoAttachment,
    IconMicWithBackground,
    IconVideoWithBackground,
    IconArrowDownOutline,
    IconArrowUpOutline,
    IconImageCircle,
    IconAttachment,
    IconClose,
    IconAddUser,
    IconArrowBack,
    IconArrowDown,
    IconArrowDownLarge,
    IconArrowLeft,
    IconArrowUp,
    IconArrowUpLarge,
    IconAudioOnly,
    IconAudioOnlyOff,
    IconBluetooth,
    IconBell,
    IconCalendar,
    IconCameraRefresh,
    IconCar,
    IconChatUnread,
    IconCheck,
    IconCloseCircle,
    IconCloseLarge,
    IconCloudUpload,
    IconCode,
    IconConnection,
    IconConnectionInactive,
    IconCopy,
    IconDeviceHeadphone,
    IconDotsHorizontal,
    IconDownload,
    IconE2EE,
    IconEdit,
    IconEnlarge,
    IconEnterFullscreen,
    IconEnvelope,
    IconEmotionsAngry,
    IconEmotionsDisgusted,
    IconEmotionsFearful,
    IconEmotionsHappy,
    IconEmotionsNeutral,
    IconEmotionsSad,
    IconEmotionsSurprised,
    IconExclamationSolid,
    IconExclamationTriangle,
    IconExitFullscreen,
    IconFaceSmile,
    IconFavorite,
    IconFavoriteSolid,
    IconFeedback,
    IconGear,
    IconGoogle,
    IconHangup,
    IconHelp,
    IconHighlight,
    IconImage,
    IconInfo,
    IconInfoCircle,
    IconMessage,
    IconMeter,
    IconMic,
    IconMicSlash,
    IconModerator,
    IconNoiseSuppressionOff,
    IconNoiseSuppressionOn,
    IconArrowRight,
    IconOffice365,
    IconPerformance,
    IconPhoneRinging,
    IconPin,
    IconPinned,
    IconPictureInPicture,
    IconPlay,
    IconPlus,
    IconRaiseHand,
    IconRecord,
    IconRecordAccount,
    IconRecordContact,
    IconRecordLead,
    IconRecordOpportunity,
    IconRemoteControlStart,
    IconRemoteControlStop,
    IconReply,
    IconRestore,
    IconRingGroup,
    IconScreenshare,
    IconSearch,
    IconSecurityOff,
    IconSecurityOn,
    IconSend,
    IconShare,
    IconShareDoc,
    IconShortcuts,
    IconSip,
    IconSites,
    IconStop,
    IconSubtitles,
    IconTileView,
    IconTrash,
    IconUserDeleted,
    IconUsers,
    IconUser,
    IconVideo,
    IconVideoOff,
    IconVolumeOff,
    IconVolumeUp,
    IconWarning,
    IconWarningCircle,
    IconWhiteboard,
    IconWhiteboardHide,
    IconWifi1Bar,
    IconWifi2Bars,
    IconWifi3Bars,
    IconYahoo,
    IconAuditorNotes,
    IconAuditorNotesHeading,
    IconAuditorNoteDelete,
    IconAuditorNoteClose,
    IconAuditorNoteEdit,
    IconPermission
};
